const buildClassName = (classNames: Array<string | null | undefined | false>) =>
  classNames.filter(Boolean).join(' ');

export default buildClassName;
